<template>
    <div class="row">
        <div class="col-md-4 form-group">
            <label for="plate" class="control-label">Targa*</label>
            <input class="form-control"  name="plate" type="text" maxlength="10"/>
        </div>
        <div class="col-md-4 form-group">
            <label for="brand_id" class="control-label">Marca*</label>
            <select ref="brand_select" class="form-control" v-model="selectedBrandId" name="brand_id">
                <option v-for="Brand in brands" :key="Brand.id" :value="Brand.id">
                    {{ Brand.name }}
                </option>
            </select>
        </div>
        <div class="col-md-4 form-group">
            <label for="brand_id" class="control-label">Modello*</label>
            <select ref="model_select" class="form-control" v-model="selectedModelId" name="model_id">
                <option v-for="Model in filteredModels" :key="Model.id" :value="Model.id">
                    {{ Model.name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        brands: {
            type: Array,
            default: () => []
        },
        models: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return {
            selectedBrandId: false,
            filteredModels: [],
            selectedModelId: false,
        }
    },
    mounted() {
        $(this.$refs.brand_select).select2().on("change", () => {
            this.selectedBrandId = $(this.$refs.brand_select).val();
        });
        $(this.$refs.model_select).select2();
    },
    beforeDestroy() {
        $(this.$refs.brand_select).select2("destroy");
        $(this.$refs.model_select).select2("destroy");
    },
    methods: {
        getFilteredModels() {
            console.log('filter', this.selectedBrandId, this.models);
            this.filteredModels = this.models.filter(model => model.vehicle_make_id == this.selectedBrandId);
        }
    },
    watch: {
        selectedBrandId() {
            this.getFilteredModels();
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/orders/carBrandModelManager.vue